<template>
  <div class="reference-value-nto-toggle">
    <div
      class="reference-value-nto-toggle__header"
      @click="opened = !opened"
    >
      <div>
        <span>Execução:</span>
        <span class="reference-value-nto-toggle__name">
          <md-tooltip v-if="name">
            <div class="reference-value-nto-toggle__tooltip-names">
              <span
                v-for="(ntoName, index) in nameParts"
                :key="`tooltip-nto-name-${index}`"
              >
                {{ ntoName }}
              </span>
            </div>
          </md-tooltip>
          {{ name }}
        </span>
      </div>
      <svg-loader
        src="/static/images/site/dropdown-arrow.svg"
        :class="{ 'reference-value-nto-toggle__arrow--up': opened }"
        class="reference-value-nto-toggle__arrow"
      />
    </div>
    <div
      v-if="opened"
      class="reference-value-nto-toggle__content"
    >
      <WarningAlert
        :alert-text="warningText"
        item-name-in-storage="exam-guide-reference-value-mask-warning"
        icon="icon-warning.svg"
        variant="reference-value"
      />
      <div class="reference-value-nto-toggle__instruction">
        Confira abaixo as versões disponíveis para utilização:
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import WarningAlert from '@/components/common/Alert.vue'

export default {
  name: 'ReferenceValueNtoToggle',
  components: {
    WarningAlert,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data: () => ({
      opened: false,
  }),
  computed: {
    nameParts() {
      return this.name.split('/').map(name => name.trim())
    },
    warningText() {
      return `
        <strong>Preciso usar sempre a máscara mais recente?</strong><br>
        Não. As datas exibidas representam a versão da máscara utilizada na liberação do
        exame e podem variar conforme a plataforma executante. Isso não significa que a
        versão mais recente seja a única válida. As versões anteriores ainda podem ser
        utilizadas. Verifique a tag <i>dataalteracao</i> para identificar sua versão utilizada.
      `
    },
  },
}
</script>

<style lang="scss">
.reference-value-nto-toggle {
  min-width: 0;
  width: 100%;
  margin-top: 12px;

  &__header {
    align-items: center;
    background-color: #f5f5f5;
    border-radius: 6px;
    color: #303030;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    font-weight: 600;
    justify-content: space-between;
    min-width: 0;
    overflow: hidden;
    padding: 12px 16px;
    width: 100%;

    > div:first-child {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
    }

    span,
    strong {
      display: block;
    }

    > div:first-child > span:first-child {
      color: #7a7a7a;
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 3px;
    }
  }

  &__arrow {
    flex-shrink: 0;
    height: 18px;
    margin: 0;
    min-width: 18px;
    transition: transform 0.3s ease;
    width: 18px;

    svg,
    path {
      fill: rgba(122, 122, 122, 1) !important;
    }

    &--up {
      transform: rotate(180deg);
    }
  }

  &__instruction {
    color: #555;
    font-size: 12px;
    margin: 12px 0;
  }

  &__content {
    background-color: #f5f5f5;
    border-radius: 0 0 6px 6px;
    margin-top: -6px;
    padding: 0 12px 12px;
  }

  .warning-alert {
    margin: 0;
  }

  &__name {
    color: #303030;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__tooltip-names {
    display: flex;
    flex-direction: column;
  }
}
</style>
